
export default function PromptVault() {
  return (
    <section className="w-full bg-black  py-8 font-fira text-white md:py-16">
      <div className="mx-auto w-[90%] md:w-[80%]">
        <div
          className="relative flex min-h-[480px] flex-col justify-end overflow-hidden rounded-2xl border border-[#FFFFFF33] bg-[url('/resources/workflowm.webp')] bg-cover bg-[center_top] bg-no-repeat md:h-[350px] md:min-h-[350px] md:flex-row md:items-stretch md:justify-start md:rounded-3xl md:bg-[url('/resources/workflowd.webp')]"
        >

          <div className="relative z-10 flex w-full flex-col justify-end gap-5 px-6 py-8 md:w-1/2 md:shrink-0 md:justify-center md:px-10 md:py-12">
            <p className="font-fira text-sm font-normal uppercase tracking-[0.18em] text-[#FFFFFF]">
              Prompt Vault
            </p>

            <h2 className="font-fira-condensed text-[30px] font-medium md:font-semibold leading-tight text-white md:text-[42px]">
              The prompts we use. The workflows we ship.
            </h2>

            <p className="font-fira text-sm leading-relaxed text-[#FFFFFF85] md:text-base">
             A new prompt or workflow every day. With the full context on what it does and when to use it.
            </p>

            {/* <Link
              to="/daily-ai-updates"
              onClick={scrollToResourceCta}
              className="w-fit rounded-lg border border-white/25 bg-transparent px-5 py-3 font-fira text-sm font-medium text-white transition hover:bg-white/5"
            >
              Join to access the Vault
            </Link> */}
          </div>
        </div>
      </div>
    </section>
  );
}
